module.exports = "https://bin.bnbstatic.com/_next/static/images/vote.banner-e4ea2b17abbe00d48becebafd6c62a51.png";